var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,20c-1.103,0-2,.897-2,2s.897,2,2,2,2-.897,2-2-.897-2-2-2Zm0,3c-.551,0-1-.448-1-1s.449-1,1-1,1,.448,1,1-.449,1-1,1Zm10-3c-1.103,0-2,.897-2,2s.897,2,2,2,2-.897,2-2-.897-2-2-2Zm0,3c-.551,0-1-.448-1-1s.449-1,1-1,1,.448,1,1-.449,1-1,1ZM18.5,0c-3.033,0-5.5,2.468-5.5,5.5s2.467,5.5,5.5,5.5,5.5-2.468,5.5-5.5S21.533,0,18.5,0Zm0,10c-2.481,0-4.5-2.019-4.5-4.5s2.019-4.5,4.5-4.5,4.5,2.019,4.5,4.5-2.019,4.5-4.5,4.5Zm.5-4.707l1.854,1.854-.707,.707-2.146-2.146V2.5h1v2.793Zm2.24,7.183c.396-.156,.773-.345,1.133-.562l-.617,3.086H6.018l.237,1.707c.103,.737,.742,1.293,1.486,1.293h12.259v1H7.741c-1.24,0-2.305-.927-2.476-2.155L3.245,2.293c-.103-.737-.742-1.293-1.486-1.293H0V0H1.759c1.24,0,2.305,.927,2.476,2.155l.256,1.845h6.66c-.066,.326-.103,.661-.125,1H4.63l1.25,9h15.056l.305-1.524Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.cef15d9f6c92b55e9b65b256c0417735.svg";
export { ForwardRef as ReactComponent };